import PropTypes from "prop-types"
import React from "react"
import { Row, Col, Card, CardBody, Label } from "reactstrap"
import { Formik, Form, Field } from "formik"

import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

import logo from "assets/images/logo.svg"
import { resetPasswordSchema } from "components/Common/validation"
import { forgotPassword } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const ForgetPasswordPage = props => {
  const { t } = useTranslation()

  document.title = t("Forget Password | Sign Burger")

  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.Login)

  const formatRemaining = seconds => {
    if (!seconds || seconds <= 0) return ""
    if (seconds < 60) {
      return seconds === 1
        ? t("second_singular")
        : t("second_plural", { count: seconds })
    }
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    const minsStr = mins === 1 ? t("minute_singular") : t("minute_plural", { count: mins })
    if (secs === 0) return minsStr
    const secsStr = secs === 1 ? t("second_singular") : t("second_plural", { count: secs })
    return `${minsStr} ${secsStr}`
  }

  const onSubmit = values => {
    dispatch(forgotPassword({ ...values, history: props.router.navigate }))
      .then(action => {
        const { statusCode, status, msg, errorCode, data } = (action && action.payload) || {}
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
          } else {
            let displayMsg = msg
            if (
              (errorCode === "RATE_LIMITED" ||
                errorCode === "OTP_RESEND_COOLDOWN" ||
                errorCode === "OTP_SEND_LIMITED") &&
              data &&
              data.remainingSeconds
            ) {
              // Build the full sentence from the dynamic time only — never
              // prepend the server's static msg in front of it.
              const translationKey =
                errorCode === "RATE_LIMITED"
                  ? "Too many password reset attempts. Please try again after {{time}}."
                  : "Too many OTP resend requests. Please try again after {{time}}."
              displayMsg = t(translationKey, { time: formatRemaining(data.remainingSeconds) })
            }
            dispatch(showAlert({ text: displayMsg, type: "error" }))
          }
      })
      .catch(() => {})
  }

  return (
    <React.Fragment>
      <div className="account-pages">
        <div className="login_form">
          <Card className="overflow-hidden">
            <div className="bg-primary-subtle">
              <Row>
                <Col xs={12}>
                  <div className="text-primary p-4">
                    <h5 className="text-primary">{t("Welcome Back !")}</h5>
                    <p>{t("Sign in to continue to Sign Burger.")}</p>
                  </div>
                </Col>
              </Row>
            </div>
            <CardBody className="pt-0">
              <div>
                <Link to="/">
                  <div className="avatar-md profile-user-wid mb-4">
                    <span className="avatar-title rounded-circle bg-light">
                      <img
                        src={logo}
                        alt=""
                        className="rounded-circle"
                        height="34"
                      />
                    </span>
                  </div>
                </Link>
              </div>
              <div className="p-2">
                <Formik
                  enableReinitialize={true}
                  initialValues={{ email: "" }}
                  validationSchema={resetPasswordSchema}
                  onSubmit={onSubmit}
                >
                  {({ touched, errors }) => (
                    <Form className="form-horizontal">
                      <div className="mb-3">
                        <Label className="form-label">{t("Email")}</Label>
                        <Field
                          name="email"
                          className={`form-control ${
                            touched.email && errors.email && "is-invalid"
                          }`}
                          placeholder={t("Email")}
                          type="email"
                        />
                        <TextError name="email" />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md"
                            type="submit"
                            disabled={loading}
                          >
                            {t("Reset")}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
              </div>
            </CardBody>
          </Card>
          <div className="text-center auth-page-footer">
            <p>
              {t("Go back to")}{" "}
              <Link to="/login" className="font-weight-medium text-black">
                {t("Login")}
              </Link>
            </p>
            <p>
              © {new Date().getFullYear()} {t("Sign Burger")}
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
